<template>
  <div id="PrintSessionView2">
    <div  class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <div style="display: flex">
          <div style="margin-right: 10px">
            活動開始日期：<br />
            <flat-pickr
              v-model="queryInfo.sActiveTime"
               :config="{ ...flatpickrConfig }"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>

          <div>
            活動結束日期：<br />
            <flat-pickr
              v-model="queryInfo.eActiveTime"
              :config="{ ...flatpickrConfig }"
              ref="endPicker"
            ></flat-pickr>
          </div>
          <div>
            參與招生宣導場次報表:<br />
            <select v-model="queryInfo.options1Value">
              <option
                v-for="item in options1"
                :key="item.value"
                :value="item.value"
              >
                {{ item.text }}
              </option></select
            ><br />
          </div>

          <button
            href="#"
            @click.prevent="getALLSessionList2()"
            class="btn btn-outline-info"
            type="button"
            style="font-size: 14px"
          >
            查詢
          </button>

          <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX22/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(queryInfo.options1Value)
                .concat('/')
                .concat(queryInfo.dptcd)
            "
            v-show="total2 > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>
        </div>
        <div v-if="queryShow">
          活動開始日期：{{ queryInfo.sActiveTime }}至活動結束日期{{ queryInfo.eActiveTime }}

        </div>
      </div>

      <b-tabs content-class="mt-3" justified>
        <b-tab title="全系">
          <div v-if="PrintSessionShow"
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="0"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                  <b-th style="min-width: 2em">管理</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr
                  v-for="(data, index) in inputData2"
                  :key="data.aid"
                  :index="index"
                  v-bind:style="{
                    background: selectedRowIndex == index ? headerColor : '',
                  }"
                  @click="selectedRowIndex = index"
                >
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      data.updateUser
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX6/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(1)
                .concat('/')
                .concat(data.name)
                .concat('/')
                .concat(queryInfo.activeClassSn)
            "
            v-show="data.number > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>{{ data.number }}
                  </b-td>
                  <b-td v-if="data.number >0">
                    <button
                      href="#"
                      @click.prevent="getALLActiveList2(data.aid, data.updateUser)"
                      class="btn btn-outline-info"
                      type="button"
                      style="font-size: 14px"
                    >
                      查閱
                    </button>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <!-- <b-pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="pageSize"
              :limit="21"
              v-if="total > pageSize"
            /> -->
          </div>
          <div v-else
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="1"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <b-th style="min-width: 2em">序號</b-th>
                  <b-th style="min-width: 3em">地區</b-th>
                  <b-th style="min-width: 3em">活動名稱</b-th>
                  <b-th style="min-width: 3em">招生類型</b-th>
                  <b-th style="min-width: 5em">活動開始時間</b-th>
                  <b-th style="min-width: 5em">活動結束時間</b-th>
                  <b-th style="min-width: 2em">本活動小組長</b-th>
                  <b-th style="min-width: 2em">經費來源</b-th>

                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr
                  v-for="(item, index) in filteredDocs2"
                  :key="item.aid"
                  :index="item.aid"
                  v-bind:style="{
                    background: selectedRowIndex == index ? headerColor : '',
                  }"
                  @click="selectedRowIndex = index"
                >
                  <b-td style="text-align: right">
                    {{ index +1 }}
                  </b-td>
                  <b-td style="text-align: left">
                    {{ item.city }}
                  </b-td>
                  <b-td style="text-align: left">{{ item.activeName }}</b-td>
                  <b-td style="text-align: left">{{ item.typeName }}</b-td>
                  <b-td style="text-align: left">{{ item.sActiveTime }}</b-td>
                  <b-td style="text-align: left">{{ item.eActiveTime }}</b-td>
                  <b-td style="text-align: left">{{ item.name }}</b-td>
                  <b-td style="text-align: left">{{ item.budgetArrayString }}</b-td>


                </b-tr>


              </b-tbody>
            </b-table-simple>

          </div>

        </b-tab>


      </b-tabs>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { tw } from "flatpickr/dist/l10n/zh-tw.js";
export default {
  name: "PrintSessionView2",
  data() {
    return {
      queryShow:false,
      id: this.$store.getters.getAllstate.user.id,
      dptcd: this.$store.getters.getAllstate.user.dptcd,
      ClassEnable: false,
      ForumEnable: false,
      ActiveName: null,
      selectedDateTime: null,
      TimeOpenShow: false,
      PrintSessionShow: false,

      options1: [{ value: 1, text: "全系" }],
      cid: null,
      aid: null,
      sn: null,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected1: null,
      editId: 0,
      over: 0,
      total: 1,
      total2: 1,
      isIE: false,
      inputData: null,
      inputData2: null,
      flatpickrConfig: {
        allowInput: true, // 允許手動輸入
        clear: true, // 顯示清除按鈕
        defaultDate: "2024-01-01", // 清除當前選擇的日期
        enableTime: false,
        weekNumbers: true,
        dateFormat: "Y-m-d",
       // altInput: true,
       // altFormat: "Y-m-d",
       
        time_24hr: false, // 這應該強制使用 12 小時制
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
          },
        },
      },
      inputData3: null,
      orglocalInputData3: null,
      localInputData3: null,
      selectedRowIndex: 0,
      TabCurrentPage:0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
      queryInfo: {
        sActiveTime: "2025-01-01",
        eActiveTime: "2025-01-01",
        dptcdName: null,
        gidName: null,
        updateUser:null,
        updateUserName: null,
        options1Value: 1,
        dptcd: this.$store.getters.getAllstate.user.dptcd,
        functionValue:3 ,// EIP統計 1需要;其他號碼:不需要只用來區別(3:系所)
        activeClassSn: 0,   // 宣導類型
      },
    };
  },
  components: {
    flatPickr,
  },
  methods: {
    handleTabChange() {
      this.queryInfo.options1Value = this.currentPage + 1;

      this.getALLSessionList2();
    },
    getActiveTime() {
      let vm = this;
      if (tools.empty(vm.queryInfo.sActiveTime)) {
        vm.queryInfo.sActiveTime = vm.flatpickrConfig.default;
      }
      if (tools.empty(vm.queryInfo.eActiveTime)) {
        vm.queryInfo.eActiveTime = vm.flatpickrConfig.default;
      }

      if (!tools.empty(vm.queryInfo.sActiveTime)) {
        const dateObject = new Date(vm.queryInfo.sActiveTime);
        // 提取日期部分
        vm.queryInfo.sActiveTime = dateObject.toISOString().split("T")[0];
      }
      if (!tools.empty(vm.queryInfo.eActiveTime)) {
        const dateObject = new Date(vm.queryInfo.eActiveTime);
        // 提取日期部分
        vm.queryInfo.eActiveTime = dateObject.toISOString().split("T")[0];
      }
    },

    getALLSessionList2() {
      let vm = this;
      vm.queryShow=true ;
      vm.currentPage = vm.queryInfo.options1Value - 1;
      vm.PrintSessionShow =true ;

      vm.getActiveTime();
      this.$http
        .put("./WebApi/HighSchoolEnrolling/GetALLSessionList2/", vm.queryInfo)
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data;
            vm.total2= vm.inputData2.length;
            console.log(vm.inputData2);
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },

    getALLActiveList2(aid,updateUser) {
     this.queryInfo.updateUser = updateUser;
      let vm = this;
      vm.currentPage = vm.queryInfo.options1Value - 1;
      vm.PrintSessionShow = false ;
      vm.queryInfo.aid = aid;
    // vm.queryInfo.updateUser = updateUser;
     // vm.getActiveTime();
      this.$http
        .put("./WebApi/HighSchoolEnrolling/GetALLActiveList2/", vm.queryInfo)
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data;
            vm.total2 = vm.inputData2.length;
            console.log(vm.inputData2);
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },


  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    filteredDocs2: function () {
      let data = [];
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.currentPage2 - 1) * this.pageSize,
          this.currentPage2 * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  created() {
    console.log("======created PrintSessionView2 =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.PrintSessionShow = true;
    // vm.getALLSessionList2();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
